module.exports = __webpack_public_path__ + "img/cloudy-night-2.ef1c6aa1.svg";